import { ItemsResponse } from '@/features/items/types/item'
import { apiClient } from '@/lib/api/api-client'
import type { Vendor } from '../types/vendor'
import type { CreateVendorProductPayload, VendorProduct } from '../types/vendorProduct'

const VENDORS_ENDPOINT = '/vendors'

export const vendorsApi = {
  getVendors: (name?: string) =>
    apiClient.get<Vendor[]>(VENDORS_ENDPOINT, {
      params: name ? { name } : undefined,
    }),

  createVendor: (vendor: Pick<Vendor, 'name' | 'contactId' | 'phone' | 'email'>) =>
    apiClient.post<Vendor>(VENDORS_ENDPOINT, vendor, undefined, true),

  updateVendor: (id: string, vendor: Partial<Vendor>) =>
    apiClient.put<Vendor>(`${VENDORS_ENDPOINT}/${id}`, vendor, undefined, true),

  deleteVendor: (id: string) => apiClient.delete<void>(`${VENDORS_ENDPOINT}/${id}`, undefined, true),

  getVendorProducts: (vendorId: string) => apiClient.get<VendorProduct[]>(`${VENDORS_ENDPOINT}/${vendorId}/products`),

  createVendorProduct: (vendorId: string, payload: CreateVendorProductPayload) =>
    apiClient.post<VendorProduct>(`${VENDORS_ENDPOINT}/${vendorId}/products`, payload, undefined, true),

  getVendorItems: (vendorId: string) => apiClient.get<ItemsResponse>(`${VENDORS_ENDPOINT}/${vendorId}/items`),
}
